var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ja-content',{attrs:{"pageTitle":_vm.$t("teams"),"page-subtitle":_vm.pageSubtitle}},[(_vm.teams.length)?_c('ja-data-table',{attrs:{"items":_vm.teams,"fields":_vm.fields,"pagination":_vm.pagination,"on-change-page":_vm.handleChangePage,"on-row-click":(row) => _vm.jaDetailView("team", row)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }